// gkc_hash_code : 01FJGW9AB4VKN1PM0CVCZY1PTE
enum ROUTES {
  LIVESTREAM_VIEW_PAGE = "/livestream/:id",
  ERROR_404 = "/404",
}

export type Params = {
  [k: string]: string;
};

export interface ViewPage extends Params {
  id: string;
}

export default ROUTES;
